import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../../graphql/common.datatypes';

interface ForgotPasswordVars {
    data: {
      cellphone: string,
      cellphone_code: string,
      code: string,
      password: string,
      password_confirmation: string,
    }
}

interface ForgotPasswordData {
  updateForgottenPasswordSms: StatusMessage
}

export const FORGOT_PASSWORD_SMS_MUTATION = gql`
    mutation updateForgottenPasswordSms($data: NewPasswordWithCodeSmsInput!) {
        updateForgottenPasswordSms(input: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const updateForgottenPasswordSms = () => useMutation<ForgotPasswordData, ForgotPasswordVars>(
  FORGOT_PASSWORD_SMS_MUTATION, {}
);

export default updateForgottenPasswordSms;
